module.exports = __webpack_public_path__ + "assets/img/9_437_big.df21f525.jpg";